import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

export const fieldsConfig: ListFieldConfig = {
  timeStamp: {
    name: 'timeStamp',
    type: ListFieldTypeEnum.dateTimeZone,
    excludeOnSearch: true,
    size: 800,
    displayName: 'History',
  },
  description: { name: 'description', isVisible: false },
  entity: { name: 'entity', isVisible: false },
  author: { name: 'author', isVisible: false },
  diff: { name: 'diff', isVisible: false },
}
